import { useState, useEffect } from "react";
import {
  fbGetGroupPaymentDetails,
  fbChangeGroupPaymentDetails,
} from "../../../../services/firebaseService/endPoints/admin/groupConfig";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../../store/adminData/adminData";
import axios from "axios";
import LoadingModal from "../../../commons/LoadingModal";
import {
  GUIDE_SETUP,
  TOPIC_SET_GENERAL_SETTINGS,
} from "../../../../constants/gettingStarted";
import { isEmailValid } from "../../../../utils/validation";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import DescriptionText from "../../../../CommonComponents/DescriptionText";
import "./PaymentDetails.css";

const PaymentDetails = () => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];
  const groupName = adminData?.data?.groupName;
  const groupDocId = adminData?.data?.id;

  const [stripeAccountId, setStripeAccountId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [updated, setUpdated] = useState(false);
  const [paypalAddress, setPaypalAddress] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    type: "error",
    message: "Invalid email address",
  });

  const groupCurrencyISO = adminData?.data?.paymentDetails?.currency || "USD";

  const setGettingStartedStatus = (groupId) => {
    useAdminDataStore
      .getState()
      .setGettingStartedItemStatus(groupId, GUIDE_SETUP, TOPIC_SET_GENERAL_SETTINGS, true);
  };

  const getPaymentDetails = () => {
    fbGetGroupPaymentDetails(currentGroup).then((details) => {
      if (details) {
        setStripeAccountId(details.stripeAccountId || "");
        setUpdated(true);
        setGettingStartedStatus(currentGroup);
      } else {
        setStripeAccountId("");
        setUpdated(false);
      }
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getPaymentDetails();
  }, [currentGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  const sendNotificationOnPaymentAddressChange = (docId, name) => {
    const url =
      `${import.meta.env.VITE_GCP_BASE_URL}/sendNotificationOnPaymentAddressChange?groupDocId=` +
      docId +
      "&groupName=" +
      name;
    axios.get(url);
  };

  const handleChangePaymentDetails = () => {
    setShowAlert({ show: false });
    if (paypalAddress) {
      const validEmail = isEmailValid(paypalAddress);
      if (validEmail) {
        setIsLoading(true);
        fbChangeGroupPaymentDetails(currentGroup, { paypalAddress }).then(() => {
          setIsLoading(false);
          setUpdated(true);
          sendNotificationOnPaymentAddressChange(groupDocId, groupName);
        });
      } else {
        setShowAlert({ show: true, type: "error", message: "Invalid email address" });
      }
    } else {
      setIsLoading(true);
      fbChangeGroupPaymentDetails(currentGroup, { paypalAddress: "" }).then(() => {
        setIsLoading(false);
        setUpdated(true);
        sendNotificationOnPaymentAddressChange(groupDocId, groupName);
      });
    }
  };

  return (
    <div className="col">
      <LoadingModal loading={isLoading} />

      <div style={{ padding: "12px" }}>
        <ScreenHeader title="Payments" />

        <div style={{ marginTop: "2px" }}>
          <DescriptionText showBackground>
            Groups can set up a Stripe account through Chant to enable
            payments for donations, store, membership packages, group tickets
            and giveaway entries. Stripe allows members to pay with Apple Pay,
            Google Pay and credit card. Payments are sent directly to your
            associated bank account. Each group is provided access to a
            private Stripe dashboard.
          </DescriptionText>
        </div>

        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "12px",
            marginTop: "2px",
          }}
        >
          <div className="payment-details-container">
            <div className="payment-details-row">
              <div className="payment-details-title">
                <p style={{ fontSize: 16, fontWeight: "bold" }}>
                  Stripe Status:{" "}
                </p>
              </div>
              <div className="payment-details-value">
                {stripeAccountId ? (
                  <span>
                    Active (
                    <a
                      href="https://dashboard.stripe.com/login"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Dashboard
                    </a>
                    )
                  </span>
                ) : (
                  <span style={{ marginLeft: 40 }}>Inactive</span>
                )}
              </div>
            </div>

            <div className="payment-details-row">
              <div className="payment-details-title">
                <p style={{ fontSize: 16, fontWeight: "bold" }}>Currency: </p>
              </div>
              <div className="payment-details-value">
                <span>{groupCurrencyISO}</span>
              </div>
            </div>
          </div>
          <div className="chant-support-container">
            <span>Questions? Reach out to </span>
            <a href="mailto:support@chant.fan">support@chant.fan</a>.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetails;
